import service from "../services/UserService";
import User from "../entities/User";

class UserApi {
    resetPassword (id) {
        return new Promise((resolve, reject) => {
            service.resetPassword(id)
                .then(res => resolve(res.data.NewPassword))
                .catch(err => reject(err));
        });
    }

    getUserByLogin (site, login) {
        const request = {
            Site: site,
            Login: login
        };

        return new Promise((resolve, reject) => {
            service.getUserByLogin(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    unlock (userId) {
        return new Promise((resolve, reject) => {
            service.unlock(userId)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    getCurrentUser () {
        return new Promise((resolve, reject) => {
            service.getUserByToken()
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    getUserById (userId) {
        return new Promise((resolve, reject) => {
            service.getUserById(userId)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    changePassword (newPassword, currentPassword, userId) {
        var request = {
            UserId: userId,
            Password: currentPassword,
            NewPassword: newPassword
        };

        return new Promise((resolve, reject) => {
            service.changePassword(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    changePasswordAndLogin (request) {
        return new Promise((resolve, reject) => {
            service.changePasswordAndLogin(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    ssoLinkUser (site, login, password, ticket) {
        var request = {
            Site: site,
            Login: login,
            Password: password,
            Ticket: ticket
        };

        return new Promise((resolve, reject) => {
            service.ssoLinkUser(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    createUser (user, newPassword) {
        user.password = newPassword;
        var request = user.toJson();

        return new Promise((resolve, reject) => {
            service.create(request)
                .then(res => resolve(new User(res.data)))
                .catch(err => reject(err));
        });
    }

    updateUser (user) {
        var request = user.toJson();
        return new Promise((resolve, reject) => {
            service.saveUserContact(request)
                .then(res => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    generatePassword (orgId) {
        return new Promise((resolve, reject) => {
            service.generatePassword(orgId)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    extend (userId, products) {
        var request = getUserProductsJson(userId, products);
        return new Promise((resolve, reject) => {
            service.extend(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    removeProducts (userId, products) {
        return new Promise((resolve, reject) => {
            service.restrict(getUserProductsJson(userId, products))
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    changeRole (userId, product, role) {
        var request = { UserId: userId, Product: product, Role: role };
        return new Promise((resolve, reject) => {
            service.assign(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    activate (userId) {
        return new Promise((resolve, reject) => {
            service.activate(userId)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    inactivate (userId) {
        return new Promise((resolve, reject) => {
            service.inactivate(userId)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    changeProductsRoles(userId, products) {
        return Promise.all(products.map(p => this.changeRole(userId, p.productName, p.roleName)));
    }


    ssoStartLogin (siteId) {
        var request = {
            Site: siteId
        };

        return new Promise((resolve, reject) => {
            service.ssoStartLogin(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    startLogin (siteId, userId, password, product, returnUrl) {
        var request = {
            Site: siteId,
            Login: userId,
            Password: password,
            Product: product,
            ReturnUrl: returnUrl
        };

        return new Promise((resolve, reject) => {
            service.startLogin(request)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    resendUserSetPasswordEmail (email) {
        return new Promise((resolve, reject) => {
            service.resendVerifyEmail(email)
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }
}

export default new UserApi();

function getUserProductsJson(userId, products) {
    return {
        UserId: userId,
        Products: products
    };
}
